export const getEnvironmentConfig = () => {
  const env = process.env.VUE_APP_ENV || '';

  try {
    switch (env) {
      case 'production':
        return require('./environment.production.js').environment;
      case 'development':
        return require('./environment.development.js').environment;
      case 'green':
        return require('./environment.green.js').environment;
      default:
        return require('./environment.js').environment;
    }
  } catch (error) {
    console.log(`Failed to load environment ${env}, using default`, error);
    return require('./environment.js').environment;
  }
};

export const environment = getEnvironmentConfig();

export const getSentryConfig = () => ({
  dsn: environment.VUE_APP_SENTRY_DSN || '',
  environment: environment.VUE_APP_SENTRY_ENV || 'local',
});
